module.exports = __webpack_public_path__ + "static/media/INZ1015.2b6aa988.pdf";